import { createFileRoute } from '@tanstack/react-router';
import { BaseDataOverview } from '../../features/baseData/baseDataOverview';

export const Route = createFileRoute('/stammdaten/')({
  component: BaseDataOverview,
});

export const StammdatenOverviewRoute = Route;
